import { render } from "./PromptManagement.vue?vue&type=template&id=0cb93b7a&scoped=true"
import script from "./PromptManagement.vue?vue&type=script&lang=js"
export * from "./PromptManagement.vue?vue&type=script&lang=js"

import "./PromptManagement.vue?vue&type=style&index=0&id=0cb93b7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb93b7a"]])

export default __exports__